import './App.css';
import Navbar from './Components/Navbar/Navbar';
import Education from './Components/Education/Education';
import Intro from './Components/Intro/Intro';
import Skills from './Components/Skills/Skills';
import Works from './Components/Works/Works';
import ContactMe from './Components/ContactMe/ContactMe';
import Footer from './Components/Footer/Footer';



function App() {

 
  return (
    <div className="App" >
   
     <div> 
      <div className='naveducBackground'>
        <Navbar/>
        <Intro/>
      </div>
        <Education/>
        <Skills/>
        <Works/>
        <ContactMe/>
        <Footer/>
</div>  
    </div>  
  );
}

export default App;
